import fieldPropsMixin from './fieldPropsMixin';

export default {
    props: {
        value: {
            type: null,
            default: null,
        },
    },
    mixins: [fieldPropsMixin],
    data() {
        return {
            innerValue: '',
        };
    },
    computed: {
        elementClasses() {
            if (this.errors[0]) {
                return 'border-red-500';
            }
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.innerValue = val;
            },
        },
        innerValue(val) {
            this.$emit('input', val);
        },
    },
};